import { SocialAuthCallback } from '@/features/auth';
import { setPageTitle } from '@/lib/utils';

export function SocialCallbackPage() {
  setPageTitle('Signing in…');
  return <SocialAuthCallback />;
}
